import React from "react";

import './CallUsButton.css';

const CallUsButton = props => {
    const cellphone = "8883702066"
    const handleButtonClick = () => {
        window.location.href = `tel:${cellphone}`;
      };
    return(
   
         <button className="call-us-button" onClick={handleButtonClick}style={{fontSize: '1.1rem', color : '#04BF7B', fontWeight: '700'}}>
        {props.phonenumber}
        </button>
   
    );
};

export default CallUsButton;